
import React from 'react';
import './App.css';
import "./fontello-0c38a2d1/css/fontello.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from 'jotai';
import Routes from "../src/Routes/Index"
import FootPrintModal from './Components/utils/FootPrintModal';

import ChangeLoginChild from './Layout/LoggedInLayout/ChangeLoginChild';
import { useHydrateAtoms } from 'jotai/utils';
import { queryClientAtom } from "jotai-tanstack-query"
import FootprintNotification from './Components/utils/FootprintNotification';

import { store } from './AtomStore/store';
// import Reload from './Pages/Home/Reload';
import NetworkError from './Components/utils/NetworkError';

import Reload from './Pages/Home/Reload';
const queryClient = new QueryClient();
const HydrateAtoms = ({ children }) => {
  useHydrateAtoms([[queryClientAtom, queryClient]])
  return children
}
const handleRetry = () => {
  window.location.reload();
};

function App() {
  return (
    <React.Fragment>
      <Provider store={store} >
        <QueryClientProvider client={queryClient}>
          <HydrateAtoms>
            <Reload />
            <Routes />

            <FootPrintModal />
            <FootprintNotification />
            {/* <Footprintinfo /> */}
            {/* <ChangeLoginChildOverlay /> */}
            <ChangeLoginChild />

            <NetworkError retry={handleRetry} />
          </HydrateAtoms >
        </QueryClientProvider>
      </Provider>
    </React.Fragment>
  );
}

export default App;
